import type { Except } from '@festina-life/core'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

import { NO_LAYER_PATH, SHARED_TENANT_PATH } from '../../../../system/constants'
import { useLazyFetchBranchChangesets } from '../../../../uiModels/api/changesets/useLazyFetchBranchChangesets'
import { useGeneralBlocks } from '../../../../uiModels/api/metaModel/useGeneralBlocks'
import { useGeneralLayers } from '../../../../uiModels/api/metaModel/useGeneralLayers'
import type { CommonDownloadOptions, DownloadButtonProps } from '../../types'
import {
  downloadConfigurationFile,
  excludeParameterValueOperationsFromBranchChangesets,
} from '../helpers'

// const useSquashConfigurationPackage =
//   ConfigurationRepositoryConfigurationFunctionsService_configurationFunctionServicePostGetSquashedPackage.useLazyQuery

type Props = DownloadButtonProps &
  Except<CommonDownloadOptions, 'shouldSquashChangesets'>

export const ExportLayerAllConfigurationButton = ({
  block,
  layer,
  shouldIncludeExtrinsicParameterValues,
  shouldIncludeBaseLayers,
  shouldIncludeBaseBranch,
  // shouldSquashChangesets, Squashing is temporarily disabled given that the backend doesn't support squashing BranchChangesets
  shouldExcludeParameterValues,
  shouldIncludeBaseBlocks,
  branchKey,
}: Props) => {
  const translate = useTranslate()

  const {
    mutateAsync: fetchLayerConfigurationPackage,
    isPending: isFetchingLayerConfigurationPackage,
  } = useLazyFetchBranchChangesets()
  // Squashing is temporarily disabled given that the backend doesn't support squashing BranchChangesets
  // const {
  //   mutateAsync: squashConfigurationPackage,
  //   isPending: isSquashingConfigurationPackage,
  // } = useSquashConfigurationPackage()
  const generalLayerKeys = useGeneralLayers(layer)
  const generalBlocks = useGeneralBlocks(block)

  const handleExportLayerBranchChangesets = async () => {
    const result = await fetchLayerConfigurationPackage({
      branchName: branchKey.name,
      server: branchKey.server,
      layer,
      shouldIncludeExtrinsicParameterValues,
      shouldIncludeBaseBranch,
      generalLayerKeys,
      block,
      shouldIncludeBaseLayers,
      shouldIncludeBaseBlocks,
      generalBlocks,
    })

    // Squashing is temporarily disabled given that the backend doesn't support squashing BranchChangesets
    // const squashedPackage =
    //   shouldSquashChangesets && result
    //     ? await squashConfigurationPackage({ requestBody: result })
    //     : result

    const downloadedPackage =
      shouldExcludeParameterValues && result
        ? excludeParameterValueOperationsFromBranchChangesets(result)
        : result

    if (downloadedPackage) {
      downloadConfigurationFile(
        downloadedPackage,
        `block-${block}-tenant-${layer?.tenantId ?? SHARED_TENANT_PATH}-layer-${layer.layerId ?? NO_LAYER_PATH}.json`,
      )
    }
  }

  const isPreparingDownload = isFetchingLayerConfigurationPackage // || isSquashingConfigurationPackage

  return (
    <Button
      onClick={handleExportLayerBranchChangesets}
      isLoading={isPreparingDownload}
      variant="primary"
    >
      {translate('branchesTree.export.layers.allLabel')}
    </Button>
  )
}
